import hash from 'object-hash'

export function hashFor(thing: any) {
    return hash(thing, {respectType: false})
}
